import { createReducer } from 'redux-act';
import actions from '../actions/MoodRatingActions';

const initialState = {
    saveMoodRatingPending: false,
    saveMoodRatingRes: null,
    saveMoodRatingError: null,

    getAllMoodRatingPending: false,
    getAllMoodRatingRes: null,
    getAllMoodRatingError: null,

    findDailyMoodRatingPending: false,
    findDailyMoodRatingRes: null,
    findDailyMoodRatingError: null,

    findAllMoodRatingPending: false,
    findAllMoodRatingRes: null,
    findAllMoodRatingError: null,

    ratingPercentPending: false,
    ratingPercentRes: null,
    ratingPercentError: null,

    dayWiseCoveragePending: false,
    dayWiseCoverageRes: null,
    dayWiseCoverageError: null,

    keyFunctionDataPending: false,
    keyFunctionDataRes: null,
    keyFunctionDataError: null,

    keyEmployeeDataPending: false,
    keyEmployeeDataRes: null,
    keyEmployeeDataError: null,
};

/* Add MoodRating Reducers */
const handleSaveMoodRatingRequest = state => {
    return {
        ...state,
        ...{
            saveMoodRatingPending: true,
            saveMoodRatingRes: null,
            saveMoodRatingError: null,
        },
    };
};
const handleSaveMoodRatingSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            saveMoodRatingPending: false,
            saveMoodRatingRes: payload,
            saveMoodRatingError: null,
        },
    };
};
const handleSaveMoodRatingError = (state, payload) => ({
    ...state,
    ...{
        saveMoodRatingPending: false,
        saveMoodRatingRes: null,
        saveMoodRatingError: payload,
    },
});


/* Get MoodRating Reducers */
const handleGetAllMoodRatingRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllMoodRatingPending: true,
            getAllMoodRatingRes: null,
            getAllMoodRatingError: null,
        },
    };
};
const handleGetAllMoodRatingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllMoodRatingPending: false,
            getAllMoodRatingRes: payload,
            getAllMoodRatingError: null,
        },
    };
};
const handleGetAllMoodRatingError = (state1, payload) => ({
    ...state1,
    ...{
        getAllMoodRatingPending: false,
        getAllMoodRatingRes: null,
        getAllMoodRatingError: payload,
    },
});

/* Get MoodRating by Department Reducers */
const handleFindDailyMoodRatingRequest = state1 => {
    return {
        ...state1,
        ...{
            findDailyMoodRatingPending: true,
            findDailyMoodRatingRes: null,
            findDailyMoodRatingError: null,
        },
    };
};
const handleFindDailyMoodRatingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            findDailyMoodRatingPending: false,
            findDailyMoodRatingRes: payload,
            findDailyMoodRatingError: null,
        },
    };
};
const handleFindDailyMoodRatingError = (state1, payload) => ({
    ...state1,
    ...{
        findDailyMoodRatingPending: false,
        findDailyMoodRatingRes: null,
        findDailyMoodRatingError: payload,
    },
});


/* Get MoodRating by Department Reducers */
const handleFindAllMoodRatingRequest = state1 => {
    return {
        ...state1,
        ...{
            findAllMoodRatingPending: true,
            findAllMoodRatingRes: null,
            findAllMoodRatingError: null,
        },
    };
};
const handleFindAllMoodRatingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            findAllMoodRatingPending: false,
            findAllMoodRatingRes: payload,
            findAllMoodRatingError: null,
        },
    };
};
const handleFindAllMoodRatingError = (state1, payload) => ({
    ...state1,
    ...{
        findAllMoodRatingPending: false,
        findAllMoodRatingRes: null,
        findAllMoodRatingError: payload,
    },
});

/* Update MoodRating Reducers*/
const handleRatingPercentRequest = state1 => {
    return {
        ...state1,
        ...{
            ratingPercentPending: true,
            ratingPercentRes: null,
            ratingPercentError: null,
        },
    };
};
const handleRatingPercentSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            ratingPercentPending: false,
            ratingPercentRes: payload,
            ratingPercentError: null,
        },
    };
};
const handleRatingPercentError = (state1, payload) => ({
    ...state1,
    ...{
        ratingPercentPending: false,
        ratingPercentRes: null,
        ratingPercentError: payload,
    },
});

/* Delete MoodRating Reducers*/
const handleDayWiseCoverageRequest = state1 => {
    return {
        ...state1,
        ...{
            dayWiseCoveragePending: true,
            dayWiseCoverageRes: null,
            dayWiseCoverageError: null,
        },
    };
};
const handleDayWiseCoverageSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            dayWiseCoveragePending: false,
            dayWiseCoverageRes: payload,
            dayWiseCoverageError: null,
        },
    };
};
const handleDayWiseCoverageError = (state1, payload) => ({
    ...state1,
    ...{
        dayWiseCoveragePending: false,
        dayWiseCoverageRes: null,
        dayWiseCoverageError: payload,
    },
});


/* Update Designation Reducers*/
const handleKeyFunctionDataRequest = state1 => {
    return {
        ...state1,
        ...{
            keyFunctionDataPending: true,
            keyFunctionDataRes: null,
            keyFunctionDataError: null,
        },
    };
};
const handleKeyFunctionDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            keyFunctionDataPending: false,
            keyFunctionDataRes: payload,
            keyFunctionDataError: null,
        },
    };
};
const handleKeyFunctionDataError = (state1, payload) => ({
    ...state1,
    ...{
        keyFunctionDataPending: false,
        keyFunctionDataRes: null,
        keyFunctionDataError: payload,
    },
});

/* Delete Designation Reducers*/
const handleKeyEmployeeDataRequest = state1 => {
    return {
        ...state1,
        ...{
            keyEmployeeDataPending: true,
            keyEmployeeDataRes: null,
            keyEmployeeDataError: null,
        },
    };
};
const handleKeyEmployeeDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            keyEmployeeDataPending: false,
            keyEmployeeDataRes: payload,
            keyEmployeeDataError: null,
        },
    };
};
const handleKeyEmployeeDataError = (state1, payload) => ({
    ...state1,
    ...{
        keyEmployeeDataPending: false,
        keyEmployeeDataRes: null,
        keyEmployeeDataError: payload,
    },
});

/* Clear MoodRating Store */
const clearMoodRatingStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_SAVE_MOOD_RATING_STORE':
            return {
                ...state,
                ...{
                    saveMoodRatingPending: false,
                    saveMoodRatingRes: null,
                    saveMoodRatingError: null,
                },
            };
        case 'HANDLE_CLEAR_RATING_PERCENT_STORE':
            return {
                ...state,
                ...{
                    ratingPercentPending: false,
                    ratingPercentRes: null,
                    ratingPercentError: null,
                },
            };
        case 'HANDLE_CLEAR_DAY_WISE_COVERAGE_STORE':
            return {
                ...state,
                ...{
                    dayWiseCoveragePending: false,
                    dayWiseCoverageRes: null,
                    dayWiseCoverageError: null,
                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.saveMoodRatingRequest]: handleSaveMoodRatingRequest,
        [actions.saveMoodRatingSuccess]: handleSaveMoodRatingSuccess,
        [actions.saveMoodRatingError]: handleSaveMoodRatingError,

        [actions.getAllMoodRatingRequest]: handleGetAllMoodRatingRequest,
        [actions.getAllMoodRatingSuccess]: handleGetAllMoodRatingSuccess,
        [actions.getAllMoodRatingError]: handleGetAllMoodRatingError,

        [actions.findDailyMoodRatingRequest]: handleFindDailyMoodRatingRequest,
        [actions.findDailyMoodRatingSuccess]: handleFindDailyMoodRatingSuccess,
        [actions.findDailyMoodRatingError]: handleFindDailyMoodRatingError,

        [actions.findAllMoodRatingRequest]: handleFindAllMoodRatingRequest,
        [actions.findAllMoodRatingSuccess]: handleFindAllMoodRatingSuccess,
        [actions.findAllMoodRatingError]: handleFindAllMoodRatingError,

        [actions.ratingPercentRequest]: handleRatingPercentRequest,
        [actions.ratingPercentSuccess]: handleRatingPercentSuccess,
        [actions.ratingPercentError]: handleRatingPercentError,

        [actions.dayWiseCoverageRequest]: handleDayWiseCoverageRequest,
        [actions.dayWiseCoverageSuccess]: handleDayWiseCoverageSuccess,
        [actions.dayWiseCoverageError]: handleDayWiseCoverageError,

        [actions.keyFunctionDataRequest]: handleKeyFunctionDataRequest,
        [actions.keyFunctionDataSuccess]: handleKeyFunctionDataSuccess,
        [actions.keyFunctionDataError]: handleKeyFunctionDataError,

        [actions.keyEmployeeDataRequest]: handleKeyEmployeeDataRequest,
        [actions.keyEmployeeDataSuccess]: handleKeyEmployeeDataSuccess,
        [actions.keyEmployeeDataError]: handleKeyEmployeeDataError,

        [actions.handleClearMoodRatingStore]: clearMoodRatingStore,
    },
    initialState,
);